import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { SettingsState } from "../types";

const getters: GetterTree<SettingsState, RootState> = {
  version: (state) => state.version,
};

export default getters;
